import React from "react";
import type { ChatHeaderProps } from "../types";

export const ChatHeader: React.FC<ChatHeaderProps> = ({ userName }) => {
  return (
    <div className="chat-header">
      <div className="chat-header-content">
        <div className="header-left">
          <div
            className="header-text"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              // backgroundColor: "red",
            }}
          >
            <h2 style={{ fontSize: "28px", backgroundColor: "black" }}>
              Cue-<i>verse</i>
            </h2>
            <p className="header-badge">Tata Play</p>
          </div>
        </div>
        <div className="header-user">
          <div className="user-status"></div>
          <span className="user-name">{userName}</span>
        </div>
      </div>
    </div>
  );
};
